import AWS from "aws-sdk";
import { REGION } from "../../env";
import { getLoggerRef } from "../../integrations/logger/logger-bridge";

/**
 * pitch: 1.1
 * lang: "en-US"
 * volume: 0.5
 * voice: "Google UK English Male"
 * @param text
 */

AWS.config.update({
  region: REGION,
})

export function speak(text: string, shouldCancel = false) {
  // Create a SpeechSynthesisUtterance
  const utterance = new SpeechSynthesisUtterance(text);

  // Select a voice
  const voices = speechSynthesis.getVoices();
  const voice = voices.find(
    (voice) => voice.name === "Google UK English Female"
  );
  if (voice) {
    utterance.voice = voice;
  }
  // Set the pitch, lang, volume
  utterance.pitch = 0.95;
  utterance.lang = "en-US";
  utterance.volume = 0.8;

  // Speak the text

  if (shouldCancel) {
    speechSynthesis.cancel();
  }

  setTimeout(() => {
    speechSynthesis.speak(utterance);
  }, 0);
  let r = setInterval(() => {
    if (!speechSynthesis.speaking) {
      clearInterval(r);
    } else {
      speechSynthesis.pause();
      speechSynthesis.resume();
    }
  }, 5000);
}

export async function uploadFileToS3(
  file: File,
  fileName: string,
  bucket: string,
  credentials: {
    AccessKeyId: string,
    SecretAccessKey: string,
    SessionToken: string,
  }
) {
  const s3 = new AWS.S3();
  if (credentials?.AccessKeyId && credentials?.SecretAccessKey) {
    // Initialize S3 with your credentials
    AWS.config.update({
      accessKeyId: credentials.AccessKeyId, // Replace with your actual access key
      secretAccessKey: credentials.SecretAccessKey, // Replace with your actual secret key
      region: REGION, // Replace with your S3 bucket's region
      signatureVersion: "v4",
      credentials: {
        accessKeyId: credentials.AccessKeyId,
        secretAccessKey: credentials.SecretAccessKey,
        sessionToken: credentials.SessionToken,
      }
    });
  }
  // ${s3_bucket_name}/app/users/${userId}/calls/${sessionId}/session-raw-video.mp4
  const params = {
    Bucket: `${bucket}/app/assets/materials`,
    Key: fileName,
    ContentType: file.type,
    Expires: 60 * 60 * 24 * 3, // URL expiry time in seconds
    ServerSideEncryption: "aws:kms",
  };
  const fileToUpload = new File([file], fileName, {
    type: file.type,
  });
  try {
    // Step 1: Get signed URL
    const signedUrl = await s3.getSignedUrlPromise("putObject", params);
    // Step 2: Use the signed URL to upload the file
    await fetch(signedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
      },
      body: fileToUpload,
    });
    return signedUrl;
  } catch (error) {
    getLoggerRef()?.error("S3 file upload failed (uploadFileToS3)", error as Error, { fileName });
    console.error("Error uploading file:", error);
  }
}

export async function uploadFullVideoToS3(
  blob: Blob,
  fileName: string,
  bucket: string,
  userId: string,
  sessionId: string,
  credentials: {
    AccessKeyId: string,
    SecretAccessKey: string,
    SessionToken: string,
  }
) {
  const s3 = new AWS.S3();
  if (credentials?.AccessKeyId && credentials?.SecretAccessKey) {
    // Initialize S3 with your credentials
    AWS.config.update({
      accessKeyId: credentials.AccessKeyId, // Replace with your actual access key
      secretAccessKey: credentials.SecretAccessKey, // Replace with your actual secret key
      region: REGION, // Replace with your S3 bucket's region
      signatureVersion: "v4",
      credentials: {
        accessKeyId: credentials.AccessKeyId,
        secretAccessKey: credentials.SecretAccessKey,
        sessionToken: credentials.SessionToken,
      }
    });
  }
  // ${s3_bucket_name}/app/users/${userId}/calls/${sessionId}/session-raw-video.mp4
  const params = {
    Bucket: `${bucket}/app/users/${userId}/calls/${sessionId}`,
    Key: fileName,
    ContentType: blob.type,
    Expires: 60 * 60 * 24 * 3, // URL expiry time in seconds
    ServerSideEncryption: "aws:kms",
  };
  const audioFile = new File([blob], fileName, {
    type: blob.type,
  });
  try {
    // Step 1: Get signed URL
    const signedUrl = await s3.getSignedUrlPromise("putObject", params);
    // Step 2: Use the signed URL to upload the file
    await fetch(signedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": blob.type,
      },
      body: audioFile,
    });
  } catch (error) {
    getLoggerRef()?.error("S3 file upload failed (uploadFullVideoToS3)", error as Error, { fileName, sessionId, userId });
    console.error("Error uploading file:", error);
  }
}

export function secondsToMinute(seconds: number) {
  // 150 seconds = 02:30
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = (seconds % 60).toFixed(0);
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.padStart(2, '0')}`;
}
